import { useContext } from 'react'

import SubmissionProvider, { SubmissionContext } from './Provider'

export { SubmissionProvider, SubmissionContext }
export type { ISubmissionContextProps } from './Provider'

export const useSubmission = () => useContext(SubmissionContext)
